import { ErrorListOutput } from '../../types';

export interface IsFeatureFlagActiveSuccessResponse {
  isFeatureActive: {
    enabled: boolean;
  };
}

export interface IsFeatureFlagActiveErrorResponse {
  isFeatureActive: ErrorListOutput & {
    enabled: never;
  };
}

export type IsFeatureFlagActiveResponse =
  | IsFeatureFlagActiveSuccessResponse
  | IsFeatureFlagActiveErrorResponse;

export const IS_FEATURE_FLAG_ACTIVE = (feature: string): string => `query {
    isFeatureActive(feature: "${feature}"){
        ... on AppConfigOutput {
            enabled
        }
        ... on ErrorListOutput {
            errors: errors {
                id
                type
                message
            }
        }
    }
  }
  `;
